import { render, staticRenderFns } from "./PointLight.vue?vue&type=template&id=4ea6589d&"
import script from "./PointLight.vue?vue&type=script&lang=js&"
export * from "./PointLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports